<script>
	import { onMount, onDestroy } from 'svelte';

    let notOnTop = false;

    const handleScroll = () => {
        if (window.scrollY == 0)
            notOnTop = false;
        else
            notOnTop = true;
    };

    onMount(() => window.addEventListener("scroll", handleScroll));
    onDestroy(() => window.addEventListener("scroll", handleScroll));
</script>

<style>
    .container {
        width: 100%;
		height: 100px;
        position: fixed;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        z-index: 20000;
        transition: height 0.3s;
    }

    @media (max-width: 1050px) {
        .container {
            display: none;
        }
	}

    .notOnTop {
        background-color: #023047;
        height: 50px;
        border-bottom: 3px solid #219EBC;
        transition: box-shadow 0.3s;
        transition: height 0.3s;
    }

    .logo {
        margin-left: 20px;
        font-weight: 700;
        font-size: 20px;
        user-select: none;
        opacity: 0;
        transition: opacity 0.3s;
        margin-top: 3px;
        width: 120px;
        height: 22px;
        background-position: center left;
        background-size: contain;
        background-repeat:no-repeat;
        background-image: url('./../images/wordmark.svg');
    }

    .logoCounterWeight {
        width: 190px;
    }

    .logoNotOnTop {
        opacity: 1;
        transition: opacity 0.3s;
    }

    .buffer {
        flex: 1 1 1px
    }

    a {
        margin-right: 20px;
        margin-left: 20px;
        font-weight: 700;
        font-size: 13px;
        cursor: pointer;
    }

    a:hover {
        text-decoration: underline;
    }

    .iconLinks {
        width: 50px;
		height: 100px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: center;
        margin-left: 20px;
    }

    .iconLinks a {
        margin-left: 10px;
        margin-right: 10px;
    }

    .twitterIcon {
        height: 15px;
        width: auto;
        margin-top: 10px;
        display: inline-block;
    }

    .githubIcon {
        height: 20px;
        width: auto;
        margin-top: 9px;
        display: inline-block;
    }

</style>

<navigation class="container" class:notOnTop>
    <a href="/">
        <div class="logo" class:logoNotOnTop={notOnTop} />
    </a>
    <div class="buffer" />
    <a href="/#preview">See it in action</a>
    <a href="/#features">Philosophy</a>
    <a href="#/docs" target="_blank">Docs</a>
    <a href="/#download">Download</a>
    <a href="/#feedback">Give a feedback</a>
    <div class="iconLinks">
        <a href="https://twitter.com/httpinessclient" target="_blank" rel="noreferrer">
            <img class="twitterIcon" src="./../images/twitter.svg" alt="twitter"/>
        </a>
        <a href="https://github.com/bognikol/httpiness" target="_blank" rel="noreferrer">
            <img class="githubIcon" src="./../images/github.svg" alt="github"/>
        </a>
    </div>
    <div class="buffer" />
    <div class="logoCounterWeight"></div>
</navigation>
